import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=693804fe&scoped=true&"
import script from "./widget.vue?vue&type=script&lang=js&"
export * from "./widget.vue?vue&type=script&lang=js&"
import style0 from "./widget.vue?vue&type=style&index=0&id=693804fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693804fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('693804fe')) {
      api.createRecord('693804fe', component.options)
    } else {
      api.reload('693804fe', component.options)
    }
    module.hot.accept("./widget.vue?vue&type=template&id=693804fe&scoped=true&", function () {
      api.rerender('693804fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/appraisalExpert/widget.vue"
export default component.exports